import { requestApi } from './Api';

export const getMyScribePatientForms = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/myscribe_ai/patient/get_forms',
    params
  });

export const getMyScribeProviderForms = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/myscribe_ai/provider/get_forms',
    params
  });

export const getMyScribeAIPrompts = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/myscribe_ai/chat/list',
    params,
    throwError: true
  });

export const getMyScribeAIPrompt = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/myscribe_ai/chat/get',
    params
  });

export const deleteMyscribeAIPrompt = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/myscribe_ai/chat/delete',
    params
  });

export const updateMyscribeAIPrompt = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/myscribe_ai/chat/update',
    params
  });

export const updateMyscribeAIMessageNote = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/myscribe_ai/chat/update_note',
    params
  });

export const getGeneralChatThreads = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/myscribe_ai/chat/general_chat/list',
    params
  });

export const getGeneralChatThreadMessages = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/myscribe_ai/chat/general_chat/get',
    params
  });

export const getMyScribeChatTemplates = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/myscribe_ai/auto_map/templates/list',
    params,
    throwError: true
  });

export const upsertMyScribeChatTemplate = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/myscribe_ai/auto_map/templates/upsert',
    params
  });

export const deleteMyScribeChatTemplate = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/myscribe_ai/auto_map/templates/delete',
    params
  });

export const deleteMyScribeTemplatesByNoteType = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/myscribe_ai/auto_map/templates/delete_by_note_type',
    params
  });

export const getMyScribeCustomization = (navigate, params, view = 'provider') =>
  requestApi({
    navigate,
    url: `/api/myscribe_ai/provider/customization/${view === 'practice' ? 'get_practice' : 'get'}`,
    params,
    throwError: true
  });

export const deleteMyScribeCustomization = (navigate) =>
  requestApi({
    navigate,
    url: '/api/myscribe_ai/provider/customization/delete'
  });

export const updateMyScribeCustomization = (navigate, params, view = 'provider') =>
  requestApi({
    navigate,
    url: `/api/myscribe_ai/provider/customization/${
      view === 'practice' ? 'update_practice' : 'update'
    }`,
    params
  });
